module.exports = __webpack_public_path__ + "img/arrow.f27fbb16.svg";